export const signupStep1Schema = {
  fields: [
    {
      name: 'email',
      label: 'Email',
      type: 'email',
      placeholder: 'you@example.com',
      required: true,
    },
    {
      name: 'mobile',
      label: 'Mobile Number',
      type: 'prefixInput',
      required: true,
      placeholder: '123 456 7890',
      options: [
        { label: 'US +1',  value: '+1' },
        { label: 'UK +44', value: '+44' },
      ]
    },
    {
      name: 'username',
      label: 'Username',
      type: 'text',
      placeholder: 'Enter your username',
      required: true,
    },
    {
      name: 'password',
      label: 'Password',
      type: 'password',
      placeholder: '••••••••',
      required: true,
    },
  ],
  buttons: [
    {
      label: 'Next',
      action: 'next',
      type: 'button',
      className: 'btn-next',
    }
  ],
};